import { Fa } from '@eltoro-ui/components'
import { useReportHub } from '../../Contexts/useReportHub'

interface ReportHubErrorAlertProps {
  className?: string
}

export const ReportHubErrorAlert: React.FC<ReportHubErrorAlertProps> = ({
  className = '',
}) => {
  const { hasErrors, allErrors, clearErrors } = useReportHub()

  if (!hasErrors || allErrors.length === 0) {
    return null
  }

  return (
    <div
      className={`bg-danger-300 mb-6 rounded-lg p-4 ${className}`}
      role="alert"
    >
      <div className="flex items-start">
        <div className="mr-3 flex h-5 w-5 flex-shrink-0 items-center justify-center">
          <Fa icon="exclamation-triangle" className="text-red-600" size={1} />
        </div>

        <div className="flex-1">
          <h3 className="mb-2 text-sm font-medium text-red-800">
            {allErrors.length === 1
              ? 'Error Loading Data'
              : 'Multiple Errors Loading Data'}
          </h3>

          <div className="text-sm">
            {allErrors.length === 1 ? (
              <p>{allErrors[0]}</p>
            ) : (
              <ul className="list-disc space-y-1 pl-5">
                {allErrors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            )}
          </div>

          <div className="mt-3">
            <button
              type="button"
              onClick={clearErrors}
              className="rounded-md py-2 text-sm font-medium"
            >
              Dismiss
            </button>
          </div>
        </div>

        <div className="ml-3 flex flex-shrink-0">
          <button
            type="button"
            onClick={clearErrors}
            className="inline-flex rounded-md p-1.5"
            aria-label="Dismiss error"
          >
            <Fa icon="times" size={1} />
          </button>
        </div>
      </div>
    </div>
  )
}
